import React from 'react';
import staffMembers from '../../cms/staff.json';
import pageIntros from '../../cms/page-intros.json';
import MemberGridPage from '../../components/pages/MemberGridPage';

const intro = pageIntros.staff || {};

const Staff = () => {
  return (
    <MemberGridPage
      members={staffMembers}
      title={intro.title}
      subtitle={intro.subtitle}
      introText={intro.intro}
      baseRoute="/staff"
      paramName="staffId"
    />
  );
};

export default Staff; 